import { errorWrapper } from 'utility/error';

import { apiClient } from './api';

// Sends a reject-suggestion request to Suggestion_Reject. The endpoint flips
// the server-side status to Rejected and returns no payload — callers should
// refetch suggestions to pick up the new status.
async function rejectSuggestion(args: {
  tenantId: string;
  suggestionId: string;
}) {
  const { tenantId, suggestionId } = args;

  // Suggestion_Reject returns ApiResult (no data field); pad the shape so it
  // matches what errorWrapper expects.
  const apiCall = apiClient
    .Suggestion_Reject(undefined, { params: { tenantId, suggestionId } })
    .then((res) => ({ ...res, data: undefined }));

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to reject suggestion',
    },
    onSuccess: () => undefined,
  });
}

export { rejectSuggestion };
